import { render, staticRenderFns } from "./WorkTasksDrawer.vue?vue&type=template&id=f88aba34&scoped=true&"
import script from "./WorkTasksDrawer.vue?vue&type=script&lang=js&"
export * from "./WorkTasksDrawer.vue?vue&type=script&lang=js&"
import style0 from "./WorkTasksDrawer.vue?vue&type=style&index=0&id=f88aba34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88aba34",
  null
  
)

export default component.exports